// Cómo sigue un editor abierto a lo que trae el servidor. Lo usan Segmentos y Cohorts.
import { ApiError } from '@/api/errors';

/** Lo mínimo de un editor: lo guardado al abrir y lo que hay en pantalla. */
export interface SyncedEditor<D> {
    original: D;
    draft: D;
}

export interface ServerFollow<E> {
    editor: E;
    /** El servidor cambió y hay cambios propios sin guardar: hay que avisar, no pisar. */
    serverChanged: boolean;
}

/**
 * Ajusta el editor a la versión del servidor. Sin cambios propios se rebasa; si el servidor ya
 * tiene lo que está en pantalla (un guardado propio), eso pasa a ser lo guardado; si no, avisa.
 */
export function followServer<D, E extends SyncedEditor<D>>(
    editor: E,
    fresh: D,
    dirty: boolean,
    same: (a: D, b: D) => boolean,
): ServerFollow<E> {
    if (same(editor.original, fresh)) return { editor, serverChanged: false };
    if (!dirty) {
        return { editor: { ...editor, original: fresh, draft: fresh }, serverChanged: false };
    }
    if (same(editor.draft, fresh)) {
        return { editor: { ...editor, original: fresh }, serverChanged: false };
    }
    return { editor, serverChanged: true };
}

/** Un 404 o 409 al escribir: lo que hay en pantalla quedó viejo y conviene releer. */
export function isStaleWriteError(error: unknown): boolean {
    return error instanceof ApiError && (error.httpStatus === 404 || error.httpStatus === 409);
}
